import { CheckCircleOutlined, LockOutlined } from "@ant-design/icons";
import { BodhiButton, BodhiInput } from "@bodhistreams/ui";
import { useId } from "react";
import "./AccountCard.css";

const AccountCard = ({
	user,
	isEditing,
	editValues,
	editErrors,
	onChangeEdit,
	onCancelEdit,
	onSave,
	isSaving,
	onResetPassword,
	isResettingPassword,
	resetPasswordMessage,
}) => {
	const uid = useId();

	return (
		<div className="profile-card bodhi-card">
			<div className="profile-card-head">
				<h2 className="profile-card-title">Account</h2>
			</div>

			{isEditing ? (
				<div className="profile-form">
					<div
						className={`profile-field${editErrors.first_name ? " profile-field-invalid" : ""}`}
					>
						<label className="profile-label" htmlFor={`${uid}-first`}>
							First Name
						</label>
						<BodhiInput
							id={`${uid}-first`}
							value={editValues.first_name}
							onChange={(e) => onChangeEdit("first_name", e.target.value)}
							placeholder="First name"
						/>
						{editErrors.first_name && (
							<span className="profile-error">{editErrors.first_name}</span>
						)}
					</div>
					<div
						className={`profile-field${editErrors.last_name ? " profile-field-invalid" : ""}`}
					>
						<label className="profile-label" htmlFor={`${uid}-last`}>
							Last Name
						</label>
						<BodhiInput
							id={`${uid}-last`}
							value={editValues.last_name}
							onChange={(e) => onChangeEdit("last_name", e.target.value)}
							placeholder="Last name"
						/>
						{editErrors.last_name && (
							<span className="profile-error">{editErrors.last_name}</span>
						)}
					</div>
					<div className="profile-form-actions">
						<BodhiButton variant="ghost" onClick={onCancelEdit}>
							Cancel
						</BodhiButton>
						<BodhiButton variant="primary" onClick={onSave} loading={isSaving}>
							Save
						</BodhiButton>
					</div>
				</div>
			) : (
				<>
					<div className="profile-rows">
						<div>
							<span className="profile-row-label">First Name</span>
							<span className="profile-row-value">
								{user?.first_name || "Not set"}
							</span>
						</div>
						<div>
							<span className="profile-row-label">Last Name</span>
							<span className="profile-row-value">
								{user?.last_name || "Not set"}
							</span>
						</div>
						<div>
							<span className="profile-row-label">Email</span>
							<span className="profile-row-value">{user?.email}</span>
						</div>
					</div>

					<div className="profile-divider" />

					<div>
						<span className="profile-section-label">Security</span>
						<BodhiButton
							variant="ghost"
							icon={<LockOutlined />}
							onClick={onResetPassword}
							loading={isResettingPassword}
						>
							Reset Password
						</BodhiButton>
						{resetPasswordMessage ? (
							<div className="profile-alert">
								<CheckCircleOutlined className="profile-alert-icon" />
								<span>{resetPasswordMessage}</span>
							</div>
						) : (
							<p className="profile-hint">
								We'll send you an email with a link to reset your password
							</p>
						)}
					</div>
				</>
			)}
		</div>
	);
};

export default AccountCard;
